// extracted by mini-css-extract-plugin
export var delivered = "DeliveryUpdateListItem_delivered__1AmVO";
export var error = "DeliveryUpdateListItem_error__GlTBe";
export var inTransit = "DeliveryUpdateListItem_inTransit__FpsgL";
export var outForDelivery = "DeliveryUpdateListItem_outForDelivery__SGesr";
export var packageShipped = "DeliveryUpdateListItem_packageShipped__KABm+";
export var processingShipment = "DeliveryUpdateListItem_processingShipment__JZcxG";
export var statusDescription = "DeliveryUpdateListItem_statusDescription__-edwr";
export var statusIcon = "DeliveryUpdateListItem_statusIcon__8fmHH";
export var statusIconContainer = "DeliveryUpdateListItem_statusIconContainer__QoQnt";
export var statusText = "DeliveryUpdateListItem_statusText__rbXFi";